export default "__VITE_ASSET__6be84e83__"